import { getUrlBase } from "datastore/database";
import { CREATE_RESERVATION_API_ERRORS } from "util/constants";

const getErrorTitle = (errorCode) => {
  switch (errorCode) {
    case CREATE_RESERVATION_API_ERRORS.SLOT_UNAVAILABLE:
      return "Slot Unavailable";
    default:
      return "Reservation Error";
  }
};

const getErrorMessage = (errorData) => {
  switch (errorData?.errorCode) {
    case CREATE_RESERVATION_API_ERRORS.SLOT_UNAVAILABLE:
      return errorData?.errorMessage;
    default:
      return "An error occurred while scheduling the reservation";
  }
};

export default async function createReservation(businessUid, data) {
  const url = `${getUrlBase()}/${businessUid}/reservation`;

  try {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });

    const responseData = await response.json();
    if (!response || !response.ok) {
      throw new Error(responseData.error);
    }

    if (responseData?.status === "error") {
      return {
        error: true,
        errorTitle: getErrorTitle(responseData?.errorCode),
        errorMessage: getErrorMessage(responseData),
      };
    }

    return responseData;
  } catch (error) {
    console.error("There was an error!", error);
    throw error;
  }
}
